module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice"
  }, [(!_vm.hasLoaded) ? _c('loader') : [_c('div', {
    staticClass: "header"
  }, [(_vm.reservation.paid) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "paid"
  }, [_vm._v("Paid")])]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.meta.name))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                " + _vm._s(_vm.meta.address) + "\n            ")])]), _vm._v(" "), _c('table', {
    staticClass: "table visible-print"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Billing")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.meta.billing))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Stay")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.reservation.name))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "roomName"
  }, [_vm._v(_vm._s(_vm.reservation.room.title))]), _c('br')]), _vm._v(" "), _c('td', [_c('small', {
    staticClass: "grey"
  }, [_vm._v("Arrival")]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "ddd, MMM Do YYYY"))), _c('br'), _vm._v("14:00")]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "grey"
  }, [_vm._v("Departure")]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.departure)), _c('br'), _vm._v("11:00")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Invoice ID")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.reservation.readableId) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date issued")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "MMM DD, YYYY")) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "info hidden-print"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-7 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-4"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                Billing\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-8 col-sm-8"
  }, [_c('span', {
    staticClass: "billing"
  }, [_vm._v(_vm._s(_vm.meta.billing))]), _c('br')])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-4 col-sm-4"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                                Stay\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-8 col-sm-8"
  }, [_c('span', [_vm._v(_vm._s(_vm.reservation.name))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "roomName"
  }, [_vm._v(_vm._s(_vm.reservation.room.title))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "arrival-departure"
  }, [_c('div', [_c('small', {
    staticClass: "grey"
  }, [_vm._v("arrival")]), _vm._v(" "), _c('small', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "ddd, MMM Do YYYY"))), _c('br'), _vm._v("14:00")])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "grey"
  }, [_vm._v("departure")]), _vm._v(" "), _c('small', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.departure)), _c('br'), _vm._v("11:00")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-5 hidden-sm hidden-xs text-right right"
  }, [_c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Invoice ID\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reservation.readableId))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Date issued\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "MMM DD, YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "visible-xs visible-sm"
  }, [_c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Invoice ID\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.reservation.id))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                            Date issued\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.reservation.arrival.date, "MMM DD, YYYY")))])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table invoice-lines"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-2 text-right"
  }, [_vm._v("Unit price")]), _vm._v(" "), _c('th', {
    staticClass: "col-sm-3 text-right"
  }, [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(_vm.reservation.room.title)), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Room")])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.days) + "  "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("night(s)")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.reservation.price / _vm.days, 2))) + "\n                    ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.reservation.price, 2))) + "\n                        ")])])]), _vm._v(" "), _vm._l((_vm.reservation.products), function(product) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(product.title)), _c('br'), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Product")])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(product.quantity) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(product.price, 2))) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(product.price * product.quantity, 2))) + "\n                        ")])])])
  }), _vm._v(" "), (_vm.reservation.numberOfBreakfasts > 0) ? _c('tr', [_c('td', [_vm._v("\n                        Breakfast"), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Product")])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.reservation.numberOfBreakfasts) + "  "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("person(s)")])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.reservation.totalPriceBreakfast / _vm.reservation.numberOfBreakfasts, 2))) + "\n                    ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.reservation.totalPriceBreakfast, 2))) + "\n                    ")])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Subtotal (excl. tax)\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total * 0.8, 2))) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("\n                    Tax\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total * 0.20, 2))) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('strong', [_c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total, 2))))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "appreciate-your-business"
  }, [_vm._v("\n            We appreciate the confidence you have placed in us and we look forward to providing you with the best possible service in the future.\n        ")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d4596c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Invoice.vue
// module id = 380
// module chunks = 1